/**
 * Normalize string for search: lowercase, trim, and remove diacritics
 */
const normalizeString = (str: string): string => {
  return str
    .toLowerCase()
    .trim()
    .normalize('NFD') // Decompose combined letters to letter + diacritic
    .replace(/[\u0300-\u036f]/g, ''); // Remove diacritics
};

export default (element: HTMLElement) => {
  const searchInput = element.querySelector<HTMLInputElement>(
    '[data-filter-role="search"]',
  );
  const categoryDropdown = element.querySelector<HTMLSelectElement>(
    '[data-filter-role="category"]',
  );
  const teamCards = element.querySelectorAll<HTMLElement>('[data-team-card]');
  const hiddenClass = element.dataset.hiddenClass || 'is-hidden';

  if (!teamCards.length) {
    // No teams to filter
    return;
  }

  const performFilter = () => {
    const searchQuery = searchInput ? normalizeString(searchInput.value) : '';
    const selectedCategory = categoryDropdown ? categoryDropdown.value : '';

    teamCards.forEach((card) => {
      const fulltext = JSON.parse(card.dataset.fulltext || '[]') as string[];
      const category = card.dataset.category || '';

      // Check if search query matches
      const searchMatches =
        searchQuery === '' ||
        fulltext.some((field) => normalizeString(field).includes(searchQuery));

      // Check if category matches
      const categoryMatches =
        selectedCategory === '' || category === selectedCategory;

      // Show or hide card based on both filters
      if (searchMatches && categoryMatches) {
        card.classList.remove(hiddenClass);
      } else {
        card.classList.add(hiddenClass);
      }
    });
  };

  // Listen to input and change events
  if (searchInput) {
    searchInput.addEventListener('input', performFilter);
  }

  if (categoryDropdown) {
    categoryDropdown.addEventListener('change', performFilter);
  }
};
